export const formatToLocalDate = (
  dateValue: Date | string | number
): string => {
  if (!dateValue) return '';

  const date = new Date(dateValue);
  return date.toISOString().split('T')[0];
};

export const formatToLocalTime = (
  timeValue: Date | string | number
): string => {
  if (!timeValue) return '';

  const date = new Date(timeValue);
  return date.toTimeString().substring(0, 5);
};

export const formatTimeToHHMM = (timeString: string): string => {
  if (!timeString) return '';

  if (/^\d{2}:\d{2}$/.test(timeString)) return timeString;

  try {
    const [hours, minutes] = timeString.split(':').map(Number);
    return `${hours.toString().padStart(2, '0')}:${
      minutes ? minutes.toString().padStart(2, '0') : '00'
    }`;
  } catch (e) {
    return timeString; // Return original if parsing fails
  }
};
